import { motion } from "framer-motion";
import type { ReactNode, CSSProperties } from "react";

// ---------------------------------------------------------------------------
// Reveal — lightweight scroll-triggered fade + translateY.
// Uses framer-motion whileInView (IntersectionObserver under the hood).
// once: true so each element only animates the first time it enters.
// ---------------------------------------------------------------------------

export function Reveal({
  children,
  delay = 0,
  y = 20,
  className,
  style,
}: {
  children: ReactNode;
  delay?: number;
  y?: number;
  className?: string;
  style?: CSSProperties;
}) {
  return (
    <motion.div
      className={className}
      style={style}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-8%" }}
      transition={{ duration: 0.5, delay, ease: [0.16, 1, 0.3, 1] }}
    >
      {children}
    </motion.div>
  );
}
